import { render, staticRenderFns } from "./cmp.vue?vue&type=template&id=4634c479&scoped=true&"
import script from "./cmp.vue?vue&type=script&lang=js&"
export * from "./cmp.vue?vue&type=script&lang=js&"
import style0 from "./cmp.vue?vue&type=style&index=0&id=4634c479&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4634c479",
  null
  
)

export default component.exports